import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateCommercialLicenseMappingFailure,
  CreateCommercialLicenseMappingRequest,
  CreateCommercialLicenseMappingSuccess,
  DeleteCommercialLicenseMappingFailure,
  DeleteCommercialLicenseMappingRequest,
  DeleteCommercialLicenseMappingSuccess,
  FetchCommercialLicenseMappingFailure,
  FetchCommercialLicenseMappingRequest,
  FetchCommercialLicenseMappingSuccess,
  FetchCommercialLicenseMappingsFailure,
  FetchCommercialLicenseMappingsRequest,
  FetchCommercialLicenseMappingsSuccess,
  OrderCommercialLicenseMappingFailure,
  OrderCommercialLicenseMappingRequest,
  OrderCommercialLicenseMappingSuccess,
  UpdateCommercialLicenseMappingFailure,
  UpdateCommercialLicenseMappingRequest,
  UpdateCommercialLicenseMappingSuccess,
} from './commercial-license-mappings.actions'
import { CommercialLicenseMappingsService } from './commercial-license-mappings.service'
import * as CommercialLicenseMappingTypes from './commercial-license-mappings.types'

@Injectable()
export class CommercialLicenseMappingsEffects {
  constructor(
    private actions: Actions,
    private CommercialLicenseMappingsService: CommercialLicenseMappingsService,
    private router: Router,
  ) {}

  FetchCommercialLicenseMappings$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        CommercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_REQUEST,
      ),
      switchMap((action: FetchCommercialLicenseMappingsRequest) => {
        return this.CommercialLicenseMappingsService.fetchCommercialLicenseMappings(
          action.payload,
        ).pipe(
          map((result) => {
            return new FetchCommercialLicenseMappingsSuccess(
              result.data.results,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchCommercialLicenseMappingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchCommercialLicenseMapping$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        CommercialLicenseMappingTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_REQUEST,
      ),
      switchMap((action: FetchCommercialLicenseMappingRequest) => {
        return this.CommercialLicenseMappingsService.fetchCommercialLicenseMapping(
          action.id,
        ).pipe(
          map((result) => {
            return new FetchCommercialLicenseMappingSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchCommercialLicenseMappingFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  OrderCommercialLicenseMapping$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        CommercialLicenseMappingTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_REQUEST,
      ),
      switchMap((action: OrderCommercialLicenseMappingRequest) => {
        return this.CommercialLicenseMappingsService.orderCommercialLicenseMapping(
          action.id,
          action.direction,
        ).pipe(
          map((result) => {
            return new OrderCommercialLicenseMappingSuccess(
              result.data.commercialLicenseMappings,
            )
          }),
          catchError((err, caught) => {
            return of(new OrderCommercialLicenseMappingFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteCommercialLicenseMapping$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        CommercialLicenseMappingTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_REQUEST,
      ),
      switchMap((action: DeleteCommercialLicenseMappingRequest) => {
        return this.CommercialLicenseMappingsService.deleteCommercialLicenseMapping(
          action.id,
        ).pipe(
          switchMap((result) => {
            return [new DeleteCommercialLicenseMappingSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteCommercialLicenseMappingFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateCommercialLicenseMapping$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        CommercialLicenseMappingTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_REQUEST,
      ),
      switchMap((action: CreateCommercialLicenseMappingRequest) => {
        return this.CommercialLicenseMappingsService.createCommercialLicenseMapping(
          action.payload,
        ).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/commercial-license-mappings'])
            return [new CreateCommercialLicenseMappingSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateCommercialLicenseMappingFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateCommercialLicenseMapping$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        CommercialLicenseMappingTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_REQUEST,
      ),
      switchMap((action: UpdateCommercialLicenseMappingRequest) => {
        return this.CommercialLicenseMappingsService.updateCommercialLicenseMapping(
          action.id,
          action.payload,
        ).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/commercial-license-mappings'])
            return [new UpdateCommercialLicenseMappingSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdateCommercialLicenseMappingFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
